import axios from 'axios'

type ErrorResponseData = {
  code?: string
  error?: string
  message?: string
  description?: string
}

const INVALID_REFRESH_TOKEN_STATUS_CODES = [401, 403, 419]

const INVALID_REFRESH_TOKEN_CODES = [
  'invalid_refresh_token',
  'refresh_token_expired',
  'token_expired',
  'invalid_token'
]

const getErrorText = (data: unknown) => {
  if (typeof data === 'string') return data

  if (!data || typeof data !== 'object') return ''

  const responseData = data as ErrorResponseData

  return [
    responseData.code,
    responseData.error,
    responseData.message,
    responseData.description
  ]
    .filter(Boolean)
    .join(' ')
}

export const isInvalidRefreshTokenError = (error: unknown) => {
  if (!axios.isAxiosError(error)) return false

  const statusCode = error.response?.status

  if (statusCode && INVALID_REFRESH_TOKEN_STATUS_CODES.includes(statusCode)) {
    return true
  }

  const errorText = getErrorText(error.response?.data).toLowerCase()

  return INVALID_REFRESH_TOKEN_CODES.some(code => errorText.includes(code))
}
